import React, { useMemo } from 'react';
import FeaturedAlbumArt from '../../Shared/FeaturedAlbumArt';

const SearchResultImage = ({ type, title, getDisplayImage, media }) => {
  const isJSON = (str) => {
    try {
      return JSON.parse(str) && !!str;
    } catch (e) {
      return false;
    }
  };

  const mediaJSON = useMemo(() => {
    if (type === 'Playlist' || type === 'Collection') {
      return JSON.parse(isJSON(media) ? media : '[]');
    }
  }, [media, type]);

  return (
    <>
      {['Playlist', 'Collection'].includes(type) && (
        <div className="resources-favourites__card__thumbnail__show">
          <FeaturedAlbumArt albumArts={mediaJSON} />
        </div>
      )}
      {!['Playlist', 'Collection'].includes(type) && (
        <img
          src={getDisplayImage()}
          alt={title}
          className="resources-favourites__card__thumbnail__show"
        />
      )}
    </>
  );
};
export default SearchResultImage;
